import ContractorProjectsView from "@/components/contractor/ContractorProjectsView";

const AdminQuoteEstimatorTab = () => {
  // Reuses the exact contractor projects experience. Admins get an
  // auto-created contractor_profile via useContractorAuth, and clicking a
  // project opens the same ProjectDetail editor used by contractors.
  return <ContractorProjectsView />;
};

export default AdminQuoteEstimatorTab;
